import util from '../util';

export const DESKING = 'DESKING';
export const DESKING_SEND_TO_SALESPERSON = 'DESKING_SEND_TO_SALESPERSON';
export const DESKINGOFFER_CREATE = 'DESKINGOFFER_CREATE';
export const DESKINGOFFER_CREATE_DEFAULT = 'DESKINGOFFER_CREATE_DEFAULT';
export const DESKINGOFFER_BULK_UPDATE = 'DESKINGOFFER_BULK_UPDATE';
export const DESKINGOFFER_DELETE = 'DESKINGOFFER_DELETE';
export const DESKINGOFFER_CRM_PUSH = 'DESKINGOFFER_CRM_PUSH';
export const SET_DESKING = 'SET_DESKING';
export const SET_DESKINGOFFERS = 'SET_DESKINGOFFERS';
export const SET_PARTIALOFFERS = 'SET_PARTIALOFFERS';

export const DESKING_REQUEST = util.requestType(DESKING);
export const DESKING_SUCCESS = util.successType(DESKING);
export const DESKING_FAILURE = util.failureType(DESKING);

export const DESKING_SEND_TO_SALESPERSON_REQUEST = util.requestType(
  DESKING_SEND_TO_SALESPERSON,
);
export const DESKING_SEND_TO_SALESPERSON_SUCCESS = util.successType(
  DESKING_SEND_TO_SALESPERSON,
);
export const DESKING_SEND_TO_SALESPERSON_FAILURE = util.failureType(
  DESKING_SEND_TO_SALESPERSON,
);

export const DESKINGOFFER_CREATE_REQUEST = util.requestType(
  DESKINGOFFER_CREATE,
);
export const DESKINGOFFER_CREATE_DEFAULT_REQUEST = util.requestType(
  DESKINGOFFER_CREATE_DEFAULT,
);
export const DESKINGOFFER_CREATE_SUCCESS = util.successType(
  DESKINGOFFER_CREATE,
);
export const DESKINGOFFER_CREATE_FAILURE = util.failureType(
  DESKINGOFFER_CREATE,
);

export const DESKINGOFFER_BULK_UPDATE_REQUEST = util.requestType(
  DESKINGOFFER_BULK_UPDATE,
);
export const DESKINGOFFER_BULK_UPDATE_SUCCESS = util.successType(
  DESKINGOFFER_BULK_UPDATE,
);
export const DESKINGOFFER_BULK_UPDATE_FAILURE = util.failureType(
  DESKINGOFFER_BULK_UPDATE,
);

export const DESKINGOFFER_DELETE_REQUEST = util.requestType(
  DESKINGOFFER_DELETE,
);
export const DESKINGOFFER_DELETE_SUCCESS = util.successType(
  DESKINGOFFER_DELETE,
);
export const DESKINGOFFER_DELETE_FAILURE = util.failureType(
  DESKINGOFFER_DELETE,
);

export const DESKINGOFFER_CRM_PUSH_REQUEST = util.requestType(
  DESKINGOFFER_CRM_PUSH,
);
export const DESKINGOFFER_CRM_PUSH_SUCCESS = util.successType(
  DESKINGOFFER_CRM_PUSH,
);
export const DESKINGOFFER_CRM_PUSH_FAILURE = util.failureType(
  DESKINGOFFER_CRM_PUSH,
);
